export const GTM_ID = 'GTM-PFB62L3'

export const LOCALES = [
  'en',
  'zh-Hans',
  'zh-Hant',
  'fr',
  'de',
  'it',
  'ja',
  'ko',
  'pt-BR',
  'ru',
  'es',
] as const

export type ILocale = (typeof LOCALES)[number]

export const DAYS_OF_THE_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const

export type IDaysOfTheWeek = (typeof DAYS_OF_THE_WEEK)[number]

export const ES_SUPPORTED_CONTENT_TYPE = [
  { label: 'Article', value: 'article' },
  { label: 'Product Detail', value: 'productDetailsPage' },
  { label: 'Product', value: 'product' },
  { label: 'Event', value: 'event' },
  { label: 'Marketing Material', value: 'marketingMaterialSet' },
  { label: 'Marketing Material Asset', value: 'downloadableAsset' },
  { label: 'Rules and Documentation', value: 'downloadableDocument' },
]

export const UA_ID = 'UA-15020098-15'

export const CARD_SERVICE_API_BASE_URL =
  'https://yed1qsoau2.execute-api.us-west-1.amazonaws.com/dev'
// // 'https://0ghng7apli.execute-api.us-east-1.amazonaws.com/dev'

// The /dashboard page builder entry whose config gates the legacy vs new metrics view
export const DASHBOARD_ENTRY_ID = '4cCCfJm6miGG3mD2yVC5cs'

// Square Scopes
// PERMISSIONS OUR SELLER MUST ACCEPT
export const SQUARE_SCOPES = [
  'MERCHANT_PROFILE_READ',
  'ITEMS_READ',
  // 'ITEMS_WRITE', // no longer required/used 2025-11-18
  // 'CUSTOMERS_READ', // no longer required/used 2025-11-18
  'ORDERS_READ',
  'INVENTORY_READ',
  // 'INVENTORY_WRITE', // no longer required/used 2025-11-18
]
